import { EKycVerificationStatus } from '@exam-center/graphql';
import { ColorPalette } from '@shared/components';

export const EKYC_STATUS_TEXT = {
  [EKycVerificationStatus.PendingApproval]: 'รอเจ้าหน้าที่ตรวจสอบ',
  [EKycVerificationStatus.Rejected]: 'ยืนยันตัวตนไม่สำเร็จ',
  [EKycVerificationStatus.Approved]: 'ยืนยันตัวตนเรียบร้อย',
  [EKycVerificationStatus.Expired]: 'หมดอายุแล้ว',
  [EKycVerificationStatus.NotStarted]: 'ยังไม่ได้ e-KYC',
  [EKycVerificationStatus.InProgress]: 'กำลัง e-KYC',
  [EKycVerificationStatus.Terminated]: 'TBD',
  [EKycVerificationStatus.NotRequired]: 'ไม่ต้องยืนยันตัวตน',
};

export const EKYC_STATUS_COLOR = {
  [EKycVerificationStatus.PendingApproval]: ColorPalette.INFO,
  [EKycVerificationStatus.Rejected]: ColorPalette.ERROR,
};
